import { Component, OnInit } from '@angular/core';
import { ListaService } from '../../_services/lista.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TipoOcupacionConfiguracionService } from '../../_services/tipo-ocupacion-configuracion.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { TipoOcupacionConfiguracion } from '../../_models/tipo-ocupacion-configuracion';
import { ListaItem } from '../../_models/lista-item';
import {CreditosDigital} from '../../_enums/enum';

@Component( {
  selector: 'app-tipo-ocupacion-configuracion-editar',
  templateUrl: 'tipo-ocupacion-configuracion-editar.component.html'
} )

export class TipoOcupacionConfiguracionEditarComponent implements OnInit {


  indicadorCheckFondo: boolean;
  indicadorCheckContrato: boolean;
  carInformacionInicial = true;
  guardando = false;
  formulario: FormGroup;
  lisOcupaciones: SelectItem[] = [];
  tipOcupacion: TipoOcupacionConfiguracion;
  submitted = false;
  lisTodosConfiguraciones: TipoOcupacionConfiguracion[] = [];
  secuencia = 0;
  tabSeleccionado: string = 'TIPOCU';
  canales  = CreditosDigital;
  listaOcupaciones: ListaItem[] = [];


  constructor( private lisServicio: ListaService,
               private tipOcupacionConfiguracionServicio: TipoOcupacionConfiguracionService,
               private route: ActivatedRoute, private location: Location,
               private fb: FormBuilder,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.tipOcupacionConfiguracionServicio.obtenerPorId( params[ 'id' ] ).subscribe( tipOcupacion => {
          this.tipOcupacion = tipOcupacion;
          this.secuencia = tipOcupacion.secuencia;
          this.cargarFormulario();
        } );
      } else {
        forkJoin( this.lisServicio.getMasterDetails( 'ListasTiposOcupaciones' ),
          this.tipOcupacionConfiguracionServicio.listado() ).subscribe( ( [ lisTiposOcupaciones, lisConfiguracionOcupaciones ] ) => {
          this.lisTodosConfiguraciones = lisConfiguracionOcupaciones;
          this.secuencia = lisConfiguracionOcupaciones.length + 1;
          this.listaOcupaciones = lisTiposOcupaciones;
          this.cargarLista( lisTiposOcupaciones );
          this.cargarFormulario();
        } );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idTipoOcupacionConfiguracion: [ this.tipOcupacion ? this.tipOcupacion.idTipoOcupacionConfiguracion : null ],
      idTipoOcupacion: [ this.tipOcupacion ? this.tipOcupacion.idTipoOcupacion : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.tipOcupacion ? this.tipOcupacion.indicadorHabilitado : false ],
      indicadorIngresos: [ this.tipOcupacion ? this.tipOcupacion.indicadorIngresos : false ],
      indicadorActivos: [ this.tipOcupacion ? this.tipOcupacion.indicadorActivos : false ],
      indicadorNumeroEmpleados: [ this.tipOcupacion ? this.tipOcupacion.indicadorNumeroEmpleados : false ],
      indicadorNivelEndeudamiento: [ this.tipOcupacion ? this.tipOcupacion.indicadorNivelEndeudamiento : false ],
      indicadorSector: [ this.tipOcupacion ? this.tipOcupacion.indicadorSector : false ],
      indicadorTipoContrato: [ this.tipOcupacion ? this.tipOcupacion.indicadorTipoContrato : false ],
      indicadorEmpleador: [ this.tipOcupacion ? this.tipOcupacion.indicadorEmpleador : false ],
      indicadorManejaActividades: [ this.tipOcupacion ? this.tipOcupacion.indicadorManejaActividades : false ],
      indicadorGenero: [ this.tipOcupacion ? this.tipOcupacion.indicadorGenero : false ],
      indicadorEdad: [ this.tipOcupacion ? this.tipOcupacion.indicadorEdad : false ],
      indicadorUnidadProductiva: [ this.tipOcupacion ? this.tipOcupacion.indicadorUnidadProductiva : false ],
      indicadorAnalizamos: [ this.tipOcupacion ? this.tipOcupacion.indicadorAnalizamos : false ],
      indicadorFlujoDigital: [ this.tipOcupacion ? this.tipOcupacion.indicadorFlujoDigital : false ],
      indicadorPagaduria: [ this.tipOcupacion ? this.tipOcupacion.indicadorPagaduria : false],
      indicadorFondoPension: [ this.tipOcupacion ? this.tipOcupacion.indicadorFondoPension : false],
      secuencia: [ this.tipOcupacion ? this.tipOcupacion.secuencia : this.secuencia ],
      auditoriaUsuario: [ this.tipOcupacion ? this.tipOcupacion.auditoriaUsuario : null ],
      auditoriaFecha: [ this.tipOcupacion ? this.tipOcupacion.auditoriaFecha : null ],
      nombreTipoOcupacion: [ this.tipOcupacion ? this.tipOcupacion.nombreTipoOcupacion : null ],
      indicadorAsignarEjecutivo: [ this.tipOcupacion ? this.tipOcupacion.indicadorAsignarEjecutivo : null],
      indicadorTipoOcupacion: [ this.tipOcupacion ? this.tipOcupacion.indicadorTipoOcupacion : false]
    } );
    this.carInformacionInicial = false;
  }

  inhabilitarChecks(){
    if(!this.f.indicadorFlujoDigital.value){
      this.f.indicadorAsignarEjecutivo.setValue(false);
    }
  }

  inhabilitarcheckFondo() {
    this.f.indicadorFondoPension.setValue(false);
  console.log(this.indicadorCheckFondo);
  }

  inhabilitarcheckContrato() {
      this.f.indicadorTipoContrato.setValue(false);
    console.log(this.indicadorCheckContrato);
  }



  cargarLista( listado: ListaItem[] ) {
    listado.map( ( s: ListaItem ) => {
      if ( !this.lisTodosConfiguraciones.find( x => x.idTipoOcupacion == s.idLista ) ) {
          this.lisOcupaciones.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && (this.f.indicadorAnalizamos.value || this.f.indicadorFlujoDigital.value)) {
      this.guardando = true;
      this.indicadorCheckContrato = false;
      this.indicadorCheckFondo = false;
      const registro = this.formulario.value;
      const tipoOcupacion = this.listaOcupaciones.find(oc => oc.idLista === registro.idTipoOcupacion);
      if ( registro.idTipoOcupacionConfiguracion ) {
        this.tipOcupacionConfiguracionServicio.actualizar( registro ).subscribe( regActualizado => {
          this.navServicio.setMesage( 2 );
          this.guardando = false;
          this.indicadorCheckContrato = true;
          this.indicadorCheckFondo = true;
          if (registro.indicadorFlujoDigital) {
            this.tipOcupacion.indicadorFlujoDigital = registro.indicadorFlujoDigital;
            this.tabSeleccionado = 'FLUDIG';
          } else {
            this.location.back();
          }
          console.log(this.indicadorCheckFondo);
          console.log(this.indicadorCheckContrato);
        } );
      } else {
        this.tipOcupacionConfiguracionServicio.crear( registro ).subscribe( regCreado => {
          this.navServicio.setMesage( 1 );
          this.guardando = false;
          if (regCreado.indicadorFlujoDigital) {
            this.tipOcupacion = regCreado;
            this.tipOcupacion.codigoTipoOcupacion = tipoOcupacion.codigo;
            this.tipOcupacion.nombreTipoOcupacion = tipoOcupacion.nombre;
            this.tabSeleccionado = 'FLUDIG';
          } else {
            this.location.back();
          }
        } );
      }
    }
  }

  get f() {
    return this.formulario.controls;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  abrirAcordeon(event: any): void {
    const opciones = {
      0: 'TIPOCU',
      1: 'FLUDIG'
    };
    this.tabSeleccionado = opciones[event.index] || 'TIPOCU';
  }

}
